export const TYPES = {
  NEXT_DROPDOWN: 'NEXT_DROPDOWN'
}

export const nextDropdown = (dropdownId = null) => ({
  type: TYPES.NEXT_DROPDOWN,
  payload: dropdownId
})



// WEBPACK FOOTER //
// ./src/actions/dropdown.js